import React from "react";
import detectEthereumProvider from "@metamask/detect-provider";
const path = require("path");
require("dotenv").config();
const axios = require("axios");
const sigUtil = require("eth-sig-util");

const alchemyKey =
  "https://polygon-mainnet.g.alchemy.com/v2/uy5Nlp6aGFPTxcPEDJrhWqfLPnZ9gVrV";
const { createAlchemyWeb3 } = require("@alch/alchemy-web3");
const web3 = createAlchemyWeb3(alchemyKey);

const contractABI = require("../atk-land-abi.json");
const contractAddress = "0x7D792e98bd1Efe92dA70E4658f7C541aC22F09a2";

const tokenContractABI = require("../atk-token-abi.json");
const tokenContractAddress = "0xF868939Ee81F04f463010BC52EAb91c0839eF08c";

const atkDelegateContractABI = require("../atk-delegate-abi.json");
const atkDelegateContractAddress = "0x53BfC5F7AFcb4da8e495a50eB5fdC4E3477a7919";

var currentStatus = {
  mintSection: [
    {
      type: "var",
      value: " Mint Land Tokens Now ",
      prev: " Approve ",
      name: "status",
    },
  ],
  statusMessage: [
    { type: "var", value: true, prev: false, name: "success" },
    { type: "var", value: false, prev: false, name: "warning" },
    { type: "var", value: false, prev: false, name: "error" },
  ],
  mintCard: [
    { type: "var", value: " Approve ", prev: " Approve ", name: "common" },
    { type: "var", value: " Approve ", prev: " Approve ", name: "grand" },
    { type: "var", value: " Approve ", prev: " Approve ", name: "iconic" },
    { type: "func", value: " Approve ", prev: " Approve ", name: "setStatus" },
    { type: "func", value: false, prev: false, name: "setApprove" },
    { type: "func", value: false, prev: false, name: "setApprove2" },
    { type: "func", value: false, prev: false, name: "setLoadState" },
  ],
};

var approvalCheck;
var approvalCheck_count = 0;

var mintCheck;
var mintCheck_count = 0;

var successful_mint = false;

var messageType = "";

var mintNonce = "";

// const delay = (ms) => new Promise((res) => setTimeout(res, ms));

var provider;

export const generateBrydgeICallData = (price, rank, count, userAddress) => {
  if (userAddress == "" || userAddress == "0x0") return [];
  var tokenContract = new web3.eth.Contract(
    tokenContractABI,
    tokenContractAddress
  );
  var collectionContract = new web3.eth.Contract(contractABI, contractAddress);
  var atkDelegateContract = new web3.eth.Contract(
    atkDelegateContractABI,
    atkDelegateContractAddress
  );
  var weiPrice = web3.utils.toWei("" + (price * count) + "", "ether");

  // starinting ICALL1
  const atkTransferData = tokenContract.methods
    .transfer(atkDelegateContractAddress, weiPrice)
    .encodeABI();
  const ICall1 = {
    _to: tokenContractAddress,
    _value: 0,
    _calldata: atkTransferData,
  };

  // starting ICALL2
  const landMintData = collectionContract.methods
    .mint_land_token(count, rank) // TODO: change to number of tokens to mint
    .encodeABI();
  const mintAndTransferData = atkDelegateContract.methods
    .handleERC721Transfer(landMintData, userAddress)
    .encodeABI();

  const ICall2 = {
    _to: atkDelegateContractAddress,
    _value: 0,
    _calldata: mintAndTransferData,
  };

  return [ICall1, ICall2];
  // return [ICall1];
};

export const connectWallet = async () => {
  provider = await detectEthereumProvider();
  if (provider) {
    try {
      const addressArray = await provider.request({
        method: "eth_requestAccounts",
      });
      const obj = {
        status: " Connected ",
        address: addressArray[0],
      };
      console.log(addressArray[0]);

      return obj;
    } catch (err) {
      return {
        address: "",
        status: "Connect Error",
      };
    }
  } else {
    return {
      address: "",
      status: "Metamask Required",
    };
  }
};

export const getCurrentWalletConnected = async () => {
  provider = await detectEthereumProvider();
  console.log("Connected Mate!");

  if (provider) {
    try {
      const addressArray = await provider.request({
        method: "eth_accounts",
      });
      if (addressArray.length > 0) {
        return {
          address: addressArray[0],
          status: " Connected ",
          provider: provider,
        };
      } else {
        return {
          address: "",
          status: "Wallet Required",
          provider: provider,
        };
      }
    } catch (err) {
      return {
        address: "",
        status: "Error Connecting",
        provider: provider,
      };
    }
  } else {
    return {
      address: "",
      status: "Metamask Required",
      provider: provider,
    };
  }
};

export const setStatusMessage = (section_, item_, message_) => {
  for (var x of currentStatus[section_]) {
    if (x["name"] == item_) {
      x["value"] = message_;
    }
  }
};

export const getStatusMessage = (section_, item_) => {
  if (item_ == "*") {
    return currentStatus[section_];
  } else {
    for (var x of currentStatus[section_]) {
      if (x["name"] == item_) {
        return x;
      }
    }
  }
};

export const approveStatus = async () => {
  var tokenContract = new web3.eth.Contract(
    tokenContractABI,
    tokenContractAddress
  );
  var allowed_ = await tokenContract.methods
    .allowance(window.ethereum.selectedAddress, contractAddress)
    .call();
  if (allowed_ > 1000000) {
    clearInterval(approvalCheck);
  }

  return allowed_;
};

export const setMessage = (message_, type_) => {
  var statusType = {};
  statusType[type_] = true;

  setStatusMessage("mintSection", "status", message_);
  setStatusMessage(
    "statusMessage",
    "error",
    statusType["error"] ? true : false
  );
  setStatusMessage(
    "statusMessage",
    "success",
    statusType["success"] ? true : false
  );
  setStatusMessage(
    "statusMessage",
    "warning",
    statusType["warning"] ? true : false
  );
};

export const monitorTransaction = async () => {
  var pageExist = true;
  var found_ = false;

  for (var i = 1; i < 400; i++) {
    await axios
      .get(
        "https://api.polygonscan.com/api?module=account&action=tokennfttx&contractaddress=" +
          contractAddress +
          "&startblock=0&endblock=99999999&page=" +
          i +
          "&offset=100&sort=asc&apikey=" +
          "AEXHMM9X3HTUQ363JHCYHNW76NFWSDB2VQ"
      )
      .then(
        (response) => {
          try {
            if (response != null && typeof response != "undefined") {
              if (
                typeof response.data != "undefined" &&
                typeof response.data.result != null
              ) {
                for (var x of response.data.result) {
                  if (x["from"] == provider.selectedAddress) {
                    if (x["nonce"] == mintNonce) {
                      var url_ =
                        "https://opensea.io/assets/matic/" +
                        contractAddress +
                        "/" +
                        x["tokenID"];
                      var link_ = document.getElementById("statusLink");
                      link_.setAttribute("href", url_);

                      successful_mint = url_;
                      setMessage(" Check it out on Opensea! ", "success");
                      //setMessage(" - "+ url_ +" - ", "success");
                      console.log(url_);
                      clearInterval(mintCheck);
                      break;
                    }
                  }
                }
              }
            } else {
              pageExist = false;
            }
          } catch {
            if (mintCheck_count <= 0) {
              setMessage(
                successful_mint
                  ? "Successful Mint - Check it out here!"
                  : " ... Mint Request Submitted, Review Wallet or Transaction! ... ",
                "success"
              );
            }
          }
        },
        (error) => {
          setMessage(
            " ... Mint Request Submitted but Unable to Query Network  ... ",
            "warning"
          );
          console.log(error);
        }
      );
  }
};

function resetMessage() {
  setTimeout(function () {
    if (messageType == "") {
      setMessage(" - Mint Land Tokens Now - ", "success");
    }
  }, 20000);
}

export const approveATK = async (price_) => {
  try {
    clearInterval(mintCheck);
  } catch {
    console.log("No Running Interval");
  }

  var declined_ = false;
  var weiPrice = web3.utils.toWei("" + price_ + "", "ether");
  var tokenContract = new web3.eth.Contract(
    tokenContractABI,
    tokenContractAddress
  );
  //await tokenContract.methods.approve(contractAddress, weiPrice).send({from: window.ethereum.selectedAddress, gas:1500000}).then((response) => {
  await tokenContract.methods
    .approve(contractAddress, weiPrice)
    .send({ from: provider.selectedAddress, gas: 2500000 })
    .then(
      (response) => {
        console.log("ATK Approval Sent");
        //setMessage("ATK Approval Pending ... ", "success");
      },
      (error) => {
        declined_ = true;
        setMessage(" - User Declined Approval Request -", "error");
        resetMessage();
      }
    );
  if (declined_ == false) {
    setMessage(" - Approval Request Submitted, Please Wait.. !", "success");
    approvalCheck_count = 30;
    approvalCheck = setInterval(function () {
      if (approvalCheck_count > 0) {
        if (approveStatus() > 0) {
          setMessage("ATK Approved", "success");
          clearInterval(approvalCheck);
        } else {
          approvalCheck_count -= 1;
        }
      } else {
        setMessage(
          " - Unable to confirm approval - Please Reivew Approval Before Minting !",
          "warning"
        );
        clearInterval(approvalCheck);
      }
    }, 10000);
  }
};

export const mintLand = async (type_, count_, price_) => {
  var walletAddress = "";
  var balance_ = "";
  //Get Wallet & Balance ...
  try {
    // walletAddress = await window.ethereum.request({
    walletAddress = await provider.request({
      method: "eth_accounts",
    });

    //balance_ = await web3.eth.getBalance(walletAddress[0]);
    //console.log(balance_);
    //console.log(walletAddress);
  } catch (err) {
    setMessage(" - No Wallet Detected -", "error");
    resetMessage();
    return { success: false, status: "No Wallet Found!" };
  }

  //Check Balance ...
  //Begin Minting Transaction...

  window.contract = await new web3.eth.Contract(contractABI, contractAddress); //loadContract();
  //set up your Ethereum transaction

  // var nonce = await web3.eth.getTransactionCount(window.ethereum.selectedAddress, 'latest');
  var nonce = await web3.eth.getTransactionCount(
    provider.selectedAddress,
    "latest"
  );
  nonce = String(nonce);
  //var price_ = String(count_ * 30000);

  var weiPrice = web3.utils.toWei("" + price_ + "", "ether");

  //Send request to API Server
  //Check Status of Public/VIP Sale
  var public_ = true;
  try {
    await axios
      .post(
        "https://qdr8akcpoj.execute-api.us-east-1.amazonaws.com/prod/verify",
        { requestType: "status" }
      )
      .then(
        (response) => {
          console.log(response);
          public_ = response.data.message;
        },
        (error) => {
          console.log(error);
        }
      );
  } catch (err) {
    console.log("Error Processing Request");

    setMessage(
      "Uh-Oh' Unexpected Error, Contact AW Staff if Error Persists",
      "error"
    );
    resetMessage();
  }

  if (public_ == false) {
    var hashSignature = "";

    var signedMessage = "";
    console.log(walletAddress[0]);

    var msgData = JSON.stringify({
      domain: {
        chainId: "137",
        name: "message",
        version: "1",
      },
      message: {
        message: walletAddress[0],
      },
      primaryType: "Login",
      types: {
        EIP712Domain: [
          { name: "name", type: "string" },
          { name: "version", type: "string" },
          { name: "chainId", type: "uint256" },
        ],
        Login: [{ name: "message", type: "string" }],
      },
    });

    //sign transaction via Metamask
    try {
      //signedMessage = await window.ethereum.request({
      signedMessage = await provider.request({
        method: "eth_signTypedData_v4",
        params: [walletAddress[0], msgData],
      });

      console.log(signedMessage);
    } catch (error) {
      console.log("Signed Message Required");
      setMessage("Valid Signature Required for VIP!", "warning");
      resetMessage();
    }
    //console.log(web3.eth.accounts.recoverTransaction(signedMessage));

    try {
      var walletRecover = sigUtil.recoverTypedSignature_v4({
        data: JSON.parse(msgData),
        sig: signedMessage,
      });
      console.log(walletRecover);
    } catch (error) {
      console.log("No Signature");
      setMessage("Valid Signature Required for VIP!", "warning");
      resetMessage();
      return;
    }

    try {
      await axios
        .post(
          "https://qdr8akcpoj.execute-api.us-east-1.amazonaws.com/prod/verify",
          {
            requestType: "verify",
            wallet: window.ethereum.selectedAddress,
            price: price_,
            type: type_,
            count: count_,
            sig_message: signedMessage,
            sig_data: msgData,
          }
        )
        .then(
          (response) => {
            //console.log(response);
            if (response.data.code == true) {
              hashSignature = response.data.message;
              console.log(nonce);
              console.log(response.data.message);
              console.log(
                "Hash Returned"
              ); /*console.log(response.data.message);*/
            }
          },
          (error) => {
            console.log(error);
          }
        );
    } catch (err) {
      console.log("Error Processing Request");
      setMessage("Error Processing Request", "error");
      resetMessage();
    }
    //

    //Mint Land Function -- uint _count, uint _type, uint _nonce, bytes memory signature
    //
    //Set Current Nonce
    mintNonce = nonce;
    var link_ = document.getElementById("statusLink");
    link_.disabled = true;
    const transactionParameters = {
      to: contractAddress, // Required except during contract publications.
      //"value":price_,
      nonce: nonce,
      from: window.ethereum.selectedAddress, // must match user's active address.
      data: window.contract.methods
        .vip_mint_land_token(walletRecover, count_, type_, nonce, hashSignature)
        .encodeABI(),
      //  'data': window.contract.methods.vib_mint_land_token(count_,type_,nonce,hashSignature).encodeABI() //make call to NFT smart contract
    };

    //Approve Contract Spending -
    //Initialize Contract -

    var tokenContract = new web3.eth.Contract(
      tokenContractABI,
      tokenContractAddress
    );

    try {
      /*
              const txHash = await window.ethereum
              .request({
                  method: 'eth_sendTransaction',
                  params: [tx_approve],
              });*/
      //await tokenContract.methods.allowance(window.ethereum.selectedAddress, contractAddress).call();
      var allowed_ = await tokenContract.methods
        .allowance(window.ethereum.selectedAddress, contractAddress)
        .call();
      console.log(allowed_);
      /* if (allowed_ < price_ || allowed_ == 0) {
             await tokenContract.methods.approve(contractAddress, weiPrice).send({from: window.ethereum.selectedAddress, gas:1500000})
                }
                */
    } catch (error) {
      console.log("Spending Not Approved");

      setMessage("Please Review Approved ATK Spending!", "warning");
      resetMessage();
    }

    //sign transaction via Metamask
    try {
      // const txHash = await window.ethereum
      const txHash = await provider
        .request({
          method: "eth_sendTransaction",
          params: [transactionParameters],
        })
        .then((response) => {
          console.log(response);

          setMessage(
            " - Transaction Sent Successfully - Checking Status ... ",
            "success"
          );
          messageType = "mint";
          mintCheck_count = 30;

          try {
            clearInterval(approvalCheck);
          } catch {
            console.log("Approval Interval not Running");
          }

          mintCheck = setInterval(function () {
            if (mintCheck_count > 0) {
              if (successful_mint) {
                clearInterval(mintCheck);
              } else {
                mintCheck_count -= 1;
                setMessage(
                  " - Transaction Sent Successfully - Checking Status - Try: (" +
                    (30 - mintCheck_count) +
                    "/30)... ",
                  "success"
                );
                monitorTransaction();
              }
            } else {
              setMessage(
                " Please Review Wallet or Opensea for Mint Status!",
                "success"
              );

              var link_ = document.getElementById("statusLink");
              link_.setAttribute(
                "href",
                "https://opensea.io/collection/atkland"
              );

              clearInterval(mintCheck);
            }
          }, 15000);
        });
    } catch (error) {
      console.log("Failed to send Transaction");
      setMessage(
        "Error - Transaction Not Sent | Please Review Metamask Submission",
        "error"
      );
      resetMessage();
    }
  } else {
    var tokenContract = new web3.eth.Contract(
      tokenContractABI,
      tokenContractAddress
    );
    try {
      //console.log(await tokenContract.methods.allowance(window.ethereum.selectedAddress, contractAddress).call());
      //await tokenContract.methods.approve(contractAddress, price_).send({from: window.ethereum.selectedAddress, gas:1500000});

      //var allowed_ = await tokenContract.methods.allowance(window.ethereum.selectedAddress, contractAddress).call();
      var allowed_ = await tokenContract.methods
        .allowance(provider.selectedAddress, contractAddress)
        .call();
      console.log(allowed_);
      if (allowed_ < price_ || allowed_ == 0) {
        // await tokenContract.methods.approve(contractAddress, weiPrice).send({from: window.ethereum.selectedAddress, gas:1500000}).then((response)=> {
        await tokenContract.methods
          .approve(contractAddress, weiPrice)
          .send({ from: provider.selectedAddress, gas: 2500000 })
          .then((response) => {
            setInterval(function () {
              messageType = "checkTransaction";
            }, 20000);
          });
      }
    } catch (error) {
      console.log("Spending Not Approved");
      setMessage("Please Review Approved ATK Spending!", "error");
      resetMessage();
    }
    //await tokenContract.methods.approve(contractAddress, price_).send({from: window.ethereum.selectedAddress, gas:1500000});
    //Set Current Nonce
    mintNonce = nonce;

    const transactionParameters = {
      to: contractAddress, // Required except during contract publications.
      //"value":price_,
      nonce: nonce,
      from: provider.selectedAddress, //window.ethereum.selectedAddress, // must match user's active address.
      data: window.contract.methods.mint_land_token(count_, type_).encodeABI(),
    };

    //sign transaction via Metamask
    try {
      //const txHash = await window.ethereum
      const txHash = await provider.request({
        method: "eth_sendTransaction",
        params: [transactionParameters],
      });
    } catch (error) {
      console.log("Failed to send Transaction");
      setMessage("Error - Transaction Not Sent", "error");
      resetMessage();
    }
  }

  return;
};
